import { Calendar } from 'primereact/calendar'
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox'

import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'
import { SelectButton, SelectButtonChangeEvent } from 'primereact/selectbutton'

import React, { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { convertToCalendarFormat, extractTime, formatDateTwo, formateDate } from 'utils/formatDate'
import { capitalizeHeader } from 'utils/helper'


interface RepeatItem {
  day: string;
  value: string;
}

type RetrainFrequency = "Every Day" | "Every Week" | "Every Month";

const checkBoxArray = ["Day", "Week", "Month", "Quarter", "Year"]
const retrainFrequencyArray = ["Every Day", "Every Week", "Every Month"]
const forecastPeriodArray = ["12 Months", "18 Months", "24 Months"]


interface DateDropDown {
  label: string
  value: string
}
const repeatDays: RepeatItem[] = [
  { day: 'S', value: "sunday" },
  { day: 'M', value: "monday" },
  { day: 'T', value: "tuesday" },
  { day: 'W', value: "wednesday" },
  { day: 'T', value: "thursday" },
  { day: 'F', value: "friday" },
  { day: 'S', value: "saturday" },
];


const getDaysInMonth = (month: number, year: number) => {
  // Create a date object for the first day of the next month
  const date = new Date(year, month + 1, 0); // 0 means last day of the previous month
  const daysCount = date.getDate(); // Get the number of days

  return Array.from({ length: daysCount }, (_, i) => ({
    label: (i + 1).toString(),
    value: (i + 1).toString(),
  }));
};


const UIFeatureConfiguration = ({ handlePrev, methods, admin_ui_config }: any) => {


  const [checkBoxOptions, setCheckBoxOptions] = useState<string[]>([])
  const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
  const [onDayDate, setOnDayDates] = useState<DateDropDown[]>([]);
  const [onDay, setOnDay] = useState<string>()
  const [startDate, setStartDate] = useState<Date>()
  const [endDate, setEndDate] = useState<Date>()

  const [selectTime, setSelectTime] = useState<Date>()

  const [repeatOn, setRepeatOn] = useState<string>()
  const [repeatOnText, setRepeatOnText] = useState<string>()



  useEffect(() => {
    if (getValues().modelretrain_frequency !== "Every Month") {
      setValue("on_day", null);
    }
    if (getValues().modelretrain_frequency !== "Every Week") {
      setValue("repeat_on", [],)
    }
  }, [getValues().modelretrain_frequency, setValue]);

useEffect(()=>{
setRepeatOnText(capitalizeHeader(repeatOn))

}, [repeatOn])

  useEffect(() => {
    //date function
    const today = new Date();
    const month = today.getMonth(); // Current month (0-11)
    const year = today.getFullYear(); // Current year

    const daysInMonth = getDaysInMonth(month, year);
    setOnDayDates(daysInMonth);

    //data set functions
    setValue("default_forecast", capitalizeHeader(admin_ui_config.default_forecast))
    setCheckBoxOptions([capitalizeHeader(admin_ui_config.default_forecast)])

    const retrainString = capitalizeHeader(admin_ui_config.modelretrain_frequency.split(" ")[0]) + " " + capitalizeHeader(admin_ui_config.modelretrain_frequency.split(" ")[1])
  
    setValue("modelretrain_frequency", retrainString)

    setValue("modelretrain_frequency_time", admin_ui_config.modelretrain_frequency_time)
    setSelectTime(convertToCalendarFormat(admin_ui_config.modelretrain_frequency_time))

    setValue("start_date", admin_ui_config.start_date)
    setStartDate(convertToCalendarFormat(admin_ui_config.start_date))

    setValue("end_date", admin_ui_config.end_date)
    setEndDate(convertToCalendarFormat(admin_ui_config.end_date))


    setValue("repeat_on", admin_ui_config.repeat_on)
    setRepeatOn(admin_ui_config.repeat_on[0])

    admin_ui_config.on_day = admin_ui_config.on_day || "";
    setValue("on_day", admin_ui_config.on_day);
    setOnDay(admin_ui_config.on_day)

    const forecastString = admin_ui_config.forecast_period.split(" ")[0] + " " + capitalizeHeader(admin_ui_config.forecast_period.split(" ")[1])
    setValue("forecast_period", forecastString)

   
    const filterCase = admin_ui_config.forecast_options.map((item: string)=>capitalizeHeader(item))

    setValue("forecast_options", filterCase)
    setCheckBoxOptions(filterCase)
  }, []);



  function handleCheckboxChange(e: CheckboxChangeEvent) {
    let _checkboxOptions = [...checkBoxOptions]


    if (e.checked) {
      _checkboxOptions.push(e.value)
    }
    else {
      _checkboxOptions.splice(_checkboxOptions.indexOf(e.value), 1)
    }

    setCheckBoxOptions(_checkboxOptions)
    setValue("forecast_options", _checkboxOptions)
  
  }


  return (

    <div className="step-preview-wrap inventory-config">
      <div className='stepper-main'>
        <div className='stepper-form'>
          <div className='grp-section'>
            <div className='stepper-wrapper'>
              <h6>Default Forecast By</h6>
              <div className='form-row'>
                <div className='form-col'>
                  <label className="form-label">Choose options to show in drop-down<i>*</i></label>
                  <div className="check-grp">
                    {checkBoxArray.map((item: string, index: number) => {
                      return <div key={index} className='check-wrap'>
                        <Checkbox inputId={`dropdownValue${index}`} name="dropdown-values"
                          value={item} onChange={handleCheckboxChange} checked={checkBoxOptions.includes(`${item}`)} />
                        <label htmlFor={`dropdownValue${index}`} className="ml-2">{item}</label>
                      </div>
                    })}
                  </div>
                </div>
                <div className='form-col'>
                  <label className="form-label">Select Default Option<i>*</i></label>


                  <Dropdown
                    value={getValues().default_forecast}
                    style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                    onChange={(e) => setValue("default_forecast", e.target.value, { shouldValidate: true })}
                    name="forecastBy"
                    id="forecastBy"
                    options={checkBoxOptions}
                    placeholder="Select Default Option"
                    optionLabel=""
                    className="outline-select multi-select"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='grp-section'>
            <div className='stepper-wrapper'>
              <div className='form-row'>
                <div className='form-col'>
                  <label className="form-label">Model Retrain Frequency<i>*</i></label>

                  <Dropdown
                    value={getValues().modelretrain_frequency}
                    style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                    onChange={(e: DropdownChangeEvent) => {
                      setValue("modelretrain_frequency", e.target.value, { shouldValidate: true })
                    }}
                    name="retrainFrequency"
                    id="retrainFrequency"
                    options={retrainFrequencyArray}
                    placeholder="Model Retrain Frequency"
                    optionLabel=""
                    className="outline-select multi-select"
                  />

                </div>
                <div className='form-col'>
                  <label className="form-label">Select Time</label>

                  <Calendar className='w-full' value={selectTime}
                    onChange={(e) => {
                      // e.value ? setSelectTime(e.value) : ""
                      setValue("modelretrain_frequency_time", extractTime(e.value ?? ""))
                    }}
                    showIcon timeOnly icon={() => <i className="pi pi-clock" />} />


                </div>
              </div>
              <div className='form-row'>
                <div className='form-col'>
                  <label className="form-label">Start Date</label>

                  <Calendar className='w-full' id="buttondisplay" value={startDate} onChange={(e) => {

                    // e.value ? setStartDate(e.value) : ""
                    setValue("start_date", formateDate(e.value ?? ""));
                  }

                  } showIcon />


                </div>
                <div className='form-col'>
                  <label className="form-label">End Date</label>


                  <Calendar className="w-full" id="buttondisplay" value={endDate} onChange={(e) => {
                    // e.value ? setEndDate(e.value) : ""
                    setValue("end_date", formateDate(e.value ?? ""));
                  }} showIcon />


                </div>
              </div>


              {getValues().modelretrain_frequency === "Every Week" &&
                <div className='form-row'>
                  <div className='form-col full-col repeat-day'>
                    <label>Repeat On</label>

                    <SelectButton value={repeatOn}
                      onChange={(e: SelectButtonChangeEvent) => {
                        setRepeatOn(e.value)
                        setValue("repeat_on", [e.value])
                      }}
                      optionLabel="day" options={repeatDays}
                      optionValue='value'/>

                  </div>
                </div>
              }

              {getValues().modelretrain_frequency === "Every Month" &&
                <div className='form-row'>
                  <div className='form-col'>
                    <label className="form-label">On Day<i>*</i></label>

                    <Dropdown
                      id="day"
                      options={onDayDate}
                      value={getValues().on_day || onDay}
                      onChange={(e: DropdownChangeEvent) => { setValue("on_day", e.target.value, { shouldValidate: true }); setOnDay(e.target.value) }}
                      placeholder="Select a day"
                      optionLabel="label"
                      style={{ width: '150px' }}
                      disabled={onDayDate.length === 0} // Disable until days are calculated
                    />

                  </div>
                </div>
              }
              <div className='form-row'>
                <div className='form-col full-col'>
                  {
                    <>
                      {(getValues().modelretrain_frequency === "Every Week" && repeatOnText !== "") && (
                        <p className='helper-text m-0 p-0'>
                          Occurs every {repeatOnText} starting {formatDateTwo(formateDate(startDate?? "")) || formatDateTwo(admin_ui_config.start_date)} until {formatDateTwo(formateDate(endDate?? "")) || formatDateTwo(admin_ui_config.end_date)} at {extractTime(selectTime ?? "")|| admin_ui_config.modelretrain_frequency_time}.
                        </p>
                      )}

                      {(getValues().modelretrain_frequency === "Every Day") && (
                        <p className='helper-text m-0 p-0'>
                          Occurs every day starting {formatDateTwo(formateDate(startDate?? "")) || formatDateTwo(admin_ui_config.start_date)} until {formatDateTwo(formateDate(endDate?? "")) || formatDateTwo(admin_ui_config.end_date)} at {extractTime(selectTime ?? "")|| admin_ui_config.modelretrain_frequency_time}.
                        </p>
                      )}

                      {(getValues().modelretrain_frequency === "Every Month") && (
                        <p className='helper-text m-0 p-0'>
                          Occurs every {admin_ui_config._on_day || onDay} of every month starting {formatDateTwo(formateDate(startDate?? "")) || formatDateTwo(admin_ui_config.start_date)} until {formatDateTwo(formateDate(endDate?? "")) || formatDateTwo(admin_ui_config.end_date)} at {extractTime(selectTime ?? "")|| admin_ui_config.modelretrain_frequency_time}.
                        </p>
                      )}
                    </>

                  }



                </div>
              </div>
            </div>
          </div>
          <div className='grp-section'>
            <div className='stepper-wrapper'>
              <div className='form-row'>
                <div className='form-col'>
                  <label className="form-label">Forecast Period</label>

                  <Dropdown
                    value={getValues().forecast_period}
                    style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
                    onChange={(e: DropdownChangeEvent) => {

                      setValue("forecast_period", e.target.value, { shouldValidate: true })
                    }}

                    name="forecastPeriod"
                    id="forecastPeriod"
                    options={forecastPeriodArray}
                    placeholder="Forecast Period"
                    optionLabel=""
                    className="outline-select multi-select"
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='stepper-footer'>
          <div className='stepper-wrapper stepper-wrapper-ft'>
            <div className='stepper-footer-inner'>
              <div className='stepper-footer-left'></div>
              <div className='stepper-footer-right'>
                <button type="button" className="grey-outline-btn mr-3" onClick={() => handlePrev()}>Previous</button>
                <button type="submit" className="outline-active-btn">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UIFeatureConfiguration
